// ─── injectPowerBIStyles ──────────────────────────────────────────────────────
// Injects global CSS for the PowerBI iframe once per page load.

const injectPowerBIStyles = () => {
    const styleId = "powerbi-fullwidth-fix";
    if (document.getElementById(styleId)) return;

    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
        .powerbi-report {
            width: 100% !important;
            height: 100% !important;
            flex: 1 1 0% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
            display: flex !important;
            flex-direction: column !important;
        }
        .powerbi-report iframe {
            width: 100% !important;
            height: 100% !important;
            flex: 1 1 0% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
            display: block !important;
            transform-origin: top left !important;
        }
        .powerbi-report iframe:-webkit-full-screen {
            background-color: #ffffff !important;
            width: 100vw !important;
            height: 100vh !important;
        }
        .powerbi-report iframe:-moz-full-screen {
            background-color: #ffffff !important;
            width: 100vw !important;
            height: 100vh !important;
        }
        .powerbi-report iframe:fullscreen {
            background-color: #ffffff !important;
            width: 100vw !important;
            height: 100vh !important;
        }
    `;

    document.head.appendChild(style);
};

export default injectPowerBIStyles;
